/**
 * setInterval variant that only fires the callback when the tab is
 * visible (document.hidden === false). Hidden tabs skip ticks — no
 * API hammering, no wasted renders, no battery drain on mobile.
 *
 * When the tab becomes visible again, polling resumes naturally on
 * the next scheduled tick (no special re-trigger needed). The returned
 * id is a normal interval id; use clearInterval to stop.
 *
 * @param {() => void | Promise<void>} callback
 * @param {number} ms
 * @returns {ReturnType<typeof setInterval>}
 */
export function setVisibleInterval(callback, ms) {
  return setInterval(() => {
    if (!document.hidden) {
      callback();
    }
  }, ms);
}
